import { render, staticRenderFns } from "./_Serve.vue?vue&type=template&id=40b58199&"
import script from "./_Serve.vue?vue&type=script&lang=js&"
export * from "./_Serve.vue?vue&type=script&lang=js&"
import style0 from "./_Serve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports